import { reactive } from "vue";

export const userStore = reactive({
  name: ''
})

export const setUserName = (name: string) => {
  userStore.name = name;
}